var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center"},[_c('transition',{attrs:{"name":"slide-swap"}},[_c('keep-alive',{attrs:{"include":"players-table"}},[_c('router-view',{attrs:{"id":"myrouter"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }